import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private isLoading$ = signal(false);

  readonly isLoading = this.isLoading$.asReadonly();

  setIsLoadingState(state: boolean) {
    this.isLoading$.set(state);
  }
}
